import { useContext, useState, useCallback, useEffect } from 'react';
import { MiawChatContext } from './src-contexts-MiawChatContext.js';
import { sendTypingIndicator } from './src-utils-miaw-api-utils.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const useMIAWTypingIndicator = () => {
  const {
    state: { enableTypingIndicator }
  } = useContext(MiawChatContext);
  const { logCustomAttributesNR } = useNRLogging();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [requestData, setRequestData] = useState();
  const {
    state: { conversationId }
  } = useContext(MiawChatContext);
  const trigger = useCallback((action) => {
    setRequestData(action);
  }, []);
  useEffect(() => {
    if (requestData) {
      if (enableTypingIndicator !== true) {
        setRequestData(void 0);
        return;
      }
      setLoading(true);
      if (conversationId) {
        logCustomAttributesNR("ca-chatbot-miaw-api-request", {
          logLevel: "info",
          message: "Starting new conversation",
          apiType: "miawTypingIndicator",
          action: requestData
        });
        sendTypingIndicator(conversationId, requestData).then((res) => {
          setData(res);
          logCustomAttributesNR("ca-chatbot-miaw-api-response", {
            logLevel: "info",
            message: "Typing indicator sent successfully",
            apiType: "miawTypingIndicator",
            action: requestData
          });
        }).catch((err) => {
          setError(err);
          logCustomAttributesNR("ca-chatbot-miaw-api-error", {
            logLevel: "error",
            message: "Failed to send typing indicator",
            apiType: "miawTypingIndicator",
            action: requestData,
            errorMessage: err.message
          });
        }).finally(() => {
          setLoading(false);
          setRequestData(void 0);
        });
      }
    }
  }, [requestData]);
  return { data, loading, error, trigger };
};

export { useMIAWTypingIndicator };
//# sourceMappingURL=src-hooks-miaw-useMIAWTypingIndicator.js.map
